var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriorityHigh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9,0.4c0.6-0.6,1.5-0.6,2.1,0L15.6,7c0.6,0.6,0.6,1.5,0,2.1l-6.5,6.5c-0.6,0.6-1.5,0.6-2.1,0L0.4,9.1 c-0.6-0.6-0.6-1.5,0-2.1c0,0,0,0,0,0L6.9,0.4z M8.3,1.1c-0.2-0.2-0.5-0.2-0.7,0L1.1,7.7c-0.2,0.2-0.2,0.5,0,0.7l6.5,6.5 c0.2,0.2,0.5,0.2,0.7,0l6.5-6.5c0.2-0.2,0.2-0.5,0-0.7L8.3,1.1L8.3,1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3,8.3l1.1-1.1L8,3.8L4.6,7.2l1.1,1.1l1.5-1.5v6h1.6v-6L10.3,8.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHigh);
export default __webpack_public_path__ + "static/media/priority-high.f7bab1f0.svg";
export { ForwardRef as ReactComponent };